import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './Components/Header'
import Service from './Components/Service'
import Contact from './Components/Contact'
import Internship from './Components/Internship'
import ArtsDrawingForm from './Components/Arts'
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import About from './Components/About'
import Cloudcomputing from './Components/Cloudcomputing'
import Mobileapp from './Components/Mobileapp'
import Kidsprograme from './Components/Kidsprograme'
import Dataengineer from './Components/Dataengineer'
import Webdevelopment from './Components/Webdevelopment'
import Careers from './Components/careers';
import Home from './Components/Home'
import Offers from './Components/Offers'
import AdminApplications from './Components/admin'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      {/* <Route path="" element={<Header />} /> */}
      <Route path="/Home" element={<Home />} />
      <Route path="/Service" element={<Service />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/About" element={<About />} />
      <Route path="/Arts" element={<ArtsDrawingForm />} />
      <Route path="/Internship" element={<Internship />} />
      <Route path="/Cloudcomputing" element={<Cloudcomputing />} />
      <Route path="/Mobileapp" element={<Mobileapp />} />
      <Route path="/youthprogram" element={<Kidsprograme />} />
      <Route path="/Dataengineer" element={<Dataengineer />} />
      <Route path="/Webdevelopment" element={<Webdevelopment />} />
      <Route path="/Careers" element={<Careers/>} />
      <Route path="/Offers" element={<Offers/>} />
      <Route path="/SGAdmin" element={<AdminApplications/>} />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();
